import { render } from "./FinancialDimensionSettings.vue?vue&type=template&id=dfe6154c"
import script from "./FinancialDimensionSettings.vue?vue&type=script&lang=js"
export * from "./FinancialDimensionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__